import {
  accountDetailsRequestHandler,
  addAccountRequestHandler,
  deleteAccountRequestHandler,
} from '../../Utilities/ApiRequestHandler';

export interface addNewLanguageAccountPayload {
  accountName: string;
  apiKey: string;
  isApiKeyValid: boolean;
}

export async function addNewLanguageServiceAccount(sessionId: string, accountPayload: addNewLanguageAccountPayload) {
  if (!sessionId || sessionId === '') return;
  const requestOptions = {
    body: JSON.stringify(accountPayload),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'x-session-id': sessionId,
    },
    method: 'POST',
  };

  return await addAccountRequestHandler(
    `${process.env.REACT_APP_API_PATH}/connections/language-service`,
    requestOptions,
  );
}

export async function getAccountDetails(sessionId: string, connectionId: string) {
  if (!sessionId || sessionId === '' || !connectionId || connectionId === '') return;
  return await accountDetailsRequestHandler(
    `${process.env.REACT_APP_API_PATH}/connections/language-service/${connectionId}`,
    {
      headers: {
        'x-session-id': sessionId,
      },
    },
    'failed_to_get_language_service',
  );
}

export async function deleteAccount(accountId: string, sessionId: string) {
  if (!sessionId || sessionId === '' || !accountId || accountId === '') return;
  return await deleteAccountRequestHandler(
    `${process.env.REACT_APP_API_PATH}/connections/language-service/${accountId}`,
    {
      method: 'DELETE',
      headers: {
        'x-session-id': sessionId,
      },
    },
    'failed_to_remove_language_service',
  );
}

export async function updateApiKey(
  sessionId: string,
  connectionId: string,
  accountPayload: addNewLanguageAccountPayload,
) {
  if (!sessionId || sessionId === '' || !connectionId || connectionId === '') return;
  return await accountDetailsRequestHandler(
    `${process.env.REACT_APP_API_PATH}/connections/language-service/${connectionId}`,
    {
      headers: {
        'x-session-id': sessionId,
      },
      method: 'POST',
      body: JSON.stringify(accountPayload),
    },
    'lang_config_update_failure',
  );
}

export async function getAllConfigurationRecords(sessionId: string) {
  if (!sessionId || sessionId === '') return;

  return await fetch(`${process.env.REACT_APP_API_PATH}/connections/configuration-records`, {
    headers: {
      'x-session-id': sessionId,
    },
  })
    .then(async (response) => {
      if (response.status === 200) {
        let json: any = await response.json();
        return {
          data: json,
          status: 200,
        };
      } else if (response.status === 403) {
        return {
          errorMessage: 'Invalid or expired session.',
          status: response.status,
        };
      } else {
        return {
          errorMessage: 'Failed to get list of accounts.',
          status: response.status,
        };
      }
    })
    .catch((error) => {
      console.error('Error:', error);
      return {
        errorMessage: 'Failed to get list of accounts.',
        status: null,
      };
    });
}
